import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

function handleRequest(): State {
  return { ...initialState, isPending: true };
}

function handleSuccess(): State {
  return { ...initialState, isSuccessful: true };
}

function handleFailure(): State {
  return { ...initialState, isFailure: true };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createProjectStatusRequested]: handleRequest,
    [events.createProjectStatusSucceeded]: handleSuccess,
    [events.createProjectStatusFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
